import React from 'react';

const ExclamationIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25281 3.46803C6.81726 -0.355162 11.5959 -1.12882 14.649 1.70504C17.702 4.5389 17.8643 12.3602 14.649 15.8089C11.4337 19.2576 4.023 18.1512 1.49955 15.8089C-1.0239 13.4667 -0.311651 7.29121 3.25281 3.46803Z"
      fill="#84E075"
      {...props}
    />
    <path
      d="M8.51546 9.972C9.31271 9.972 9.73196 9.61963 9.7732 8.91489L9.94845 6.21837C9.97595 5.85405 9.85223 5.5614 9.57732 5.34043C9.30928 5.11348 8.95189 5 8.50515 5C8.05842 5 7.69759 5.11348 7.42268 5.34043C7.15464 5.5614 7.03436 5.85405 7.06186 6.21837L7.2268 8.93281C7.27491 9.62561 7.70447 9.972 8.51546 9.972ZM8.51546 13C8.94845 13 9.30241 12.9015 9.57732 12.7044C9.85911 12.5073 10 12.2296 10 11.8712C10 11.5248 9.85911 11.2501 9.57732 11.047C9.30241 10.844 8.94845 10.7424 8.51546 10.7424C8.08247 10.7424 7.72165 10.844 7.43299 11.047C7.14433 11.2441 7 11.5189 7 11.8712C7 12.2236 7.14433 12.5013 7.43299 12.7044C7.72165 12.9015 8.08247 13 8.51546 13Z"
      fill="white"
    />
  </svg>
);

export default ExclamationIcon;
